module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/object/get-own-property-descriptor.js
// module id = 22
// module chunks = 0 1